import React from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '/home/sygitech/Downloads/v-1.5/jumbo-react/source/src/Service/PostData';
import {PostCarData} from '/home/sygitech/Downloads/v-1.5/jumbo-react/source/src/Service/PostCarData';
import {PostAccountData} from '/home/sygitech/Downloads/v-1.5/jumbo-react/source/src/Service/PostAccountData';

import ContainerHeader from 'components/ContainerHeader/index';
import CardBox from "components/CardBox/index";

class Intranet extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            first_name : '',
            last_name : '',
            mobile : '',
            email : '',
            license_no : '',
            registration : '',
            make : '',
            color : '',
            model : '',
            engine_no : '',
            fuel_type : '',
            car_type : '',
            seats : '',
            address : '',
            uid: '',
            panCard : '',
            acct_no : '',
            ifsc : '',
            acct_holder : '',
            bank_name : '',
            branch : '',
            user_type: 'D',

        };
        this.onChange = this.onChange.bind(this);
    }
    state = {
        message: '',
        driver_id : '',
        user_id : '',
        redirectToReferrer: false,
    };
    signUp(e){
        e.preventDefault();
        console.log('this.state', this.state);
        PostData('create', this.state).then((result) => {
            let responseJson = result;
            if(responseJson.Response.Status == 200 && responseJson.Response.Message == 'record added') {
                    this.setState({driver_id: responseJson.Response.Data.id});
                    this.setState({user_id: responseJson.Response.Data.id});
                    this.setState({message: responseJson.Response.Message});
                    PostCarData('create', this.state).then((result) => {
                        let responseJson1 = result;
                        if(responseJson1.Response.Status == 200 && responseJson1.Response.Message == 'record added') {
                                this.setState({message: responseJson1.Response.Message});
                                PostAccountData('save', this.state).then((result) => {
                                    let responseJson2 = result;
                                    if(responseJson1.Response.Status == 200 && responseJson1.Response.Message == 'record added') {
                                        this.setState({redirectToReferrer: true});
                                        this.setState({message: responseJson2.Response.Message});
                                    } else {
                                        this.setState({redirectToReferrer: false});
                                        this.setState({message: responseJson2.Response.Message});
                                    }

                                });
                            } else {
                                this.setState({redirectToReferrer: false});
                                this.setState({message: responseJson1.Response.Message});
                            }
                    });
                    
                } else {
                    this.setState({redirectToReferrer: false});
                    this.setState({message: responseJson.Response.Message});
                }
                
        });
    }
    showMessage(){
        return(
                <div>
                    <h3>{this.state.message}</h3>
                </div>
        )
    }
    onChange(e){
        this.setState({[e.target.name]:e.target.value});
    }

    render() {
        if(!sessionStorage.getItem('userData')) {
            return ( <Redirect to={'/login'}/> );
        }
        return (
            <div className="animated slideInUpTiny animation-duration-3">
                <ContainerHeader match={this.props.match} title="Drivers"/>
                <CardBox styleName="col-lg-12" childrenStyle="d-flex justify-content-center" heading="Personal Details">
                    {this.showMessage()}
                    <form className="row" autoComplete="off" method="post" onSubmit={this.signUp.bind(this)}>
                        
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "first_name" placeholder="First Name" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "last_name" placeholder="Last Name" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "mobile" placeholder="Mobile No." className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="email" name = "email" placeholder="Email" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "license_no" placeholder="License No." className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "registration" placeholder="Registration No." className="form-control form-control-lg" margin="normal" fullWidth onChange={this.onChange} required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "make" placeholder="Vehicle Name" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "color" placeholder="Vehicle Color" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "model" placeholder="Vehicle Model" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "engine_no" placeholder="Vehicle Engine Number" className="form-control form-control-lg" margin="normal" fullWidth onChange={this.onChange} required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "fuel_type" placeholder="Vehicle Fuel Type" className="form-control form-control-lg" margin="normal" fullWidth onChange={this.onChange} required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "car_type" placeholder="Vehicle Type" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "address" placeholder="Address" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "uid" placeholder="Adhaar Card" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "panCard" placeholder="Pan Card" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "seats" placeholder="No. of seats" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
            
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "acct_no" placeholder="Account Number" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "ifsc" placeholder="IFSC Code" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "acct_holder" placeholder="Account Holder Name" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "bank_name" placeholder="Bank Name" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                                
                        <div className="col-md-3 col-12 form-group">
                            <input type="text" name = "branch" placeholder="Bank Branch" className="form-control form-control-lg" onChange={this.onChange} margin="normal" fullWidth required/>
                        </div>
                    
                        <CardBox styleName="col-lg-12 form-group" childrenStyle="d-flex justify-content-center" heading="">
                                <button type="submit" className="btn jr-btn-rounded btn-primary btn-rounded" >
                                    Register
                                </button>    
                        </CardBox>
                        <CardBox styleName="col-lg-12 form-group" childrenStyle="d-flex justify-content-center" heading="">
                            <p>Have an account?  <a className="text-primary" href="#/login">Sign in</a></p>
                        </CardBox>
                    </form>
                </CardBox>       
            </div>
        );
    }
}

export default Intranet;


// WEBPACK FOOTER //
// ./app/routes/dashboard/routes/Intranet/index.js